<template>
  <div>
    <div v-if="!hasErrors" id="homeView" class="grid--main">

      <section class="top elevation-1">
        <!-- Branding -->
        <div class="branding">
          <a href="http://statescoop.com/ransomware-attacks-map-state-local-government" target="_blank" rel="noopener noreferrer">
            <img src="../assets/ransomewareattacksmaplogo.svg" style="max-width: 165px" />
          </a>
          <!-- <div class="sponsor elevation-1" style="margin-left:10px;">
            <h4>Underwritten by</h4>
            <a href="https://www.veritas.com/solution/government" target="_blank">
              <img :src="sponsor" alt="StateScoop Ransomware Map Sponsor">
            </a>
          </div> -->
        </div>
        <!-- Filters -->
        <div class="filters">
          <div class="title">Filter By:</div>
          <!-- States -->
          <div class="filter">
            <div class="label">States</div>
            <v-select
              class="filter-select"
              v-model="filteredState"
              :options="['All', ...states]"
              label="state"
              :clearable="false"
            />
          </div>
          <!-- Amount map.filters( () => <filter :options /> ) -->
          <div class="filter">
            <div class="label">Ransom Amount</div>
            <v-select 
              class="filter-select"
              v-model="filteredCostRange" 
              :options="['All', ...costRange]" 
              :clearable="false"
              label="text" 
            >
            </v-select>
          </div>
          <!-- Type -->
          <div class="filter">
            <div>Type of ransomware</div>
            <v-select 
              class="filter-select"
              :options="['All', ...ransomewareTypes ]"
              v-model="filteredName"
              label="type"
              :clearable="false"
            />
          </div>
        </div>
      </section>

      <section class="map elevation-0">
        <Map 
          :datasource="RandsomwareAttacksDataset"
          :dataset.sync="filteredDataset"
          @topojson-error="onMapFailure"
          />
      </section>

      <section v-if="enableCounter" class="stats2">
        <div class="active-events elevation-1">
          ATTACKS
          <hr style="margin-bottom: 0px; margin-top: 2px;">
          <div class="num">{{filteredDataset.length}}</div>
        </div>
      </section>

      <section v-if="enableSlider" class="bottom elevation-1">
        <slider 
          :data="datasetDates"
          :min="filteredDateMin"
          :max="filteredDateMax"
          :onChange="(value) => onSliderChange(value)"
        />
      </section>
    
    </div>
    <div id="errors" v-if="hasErrors">
      {{errors}}
    </div>
  </div>
</template>

<script>
import {fetch as fetchPolyfill} from 'whatwg-fetch'
import Map from "@/components/Map.vue"; // @ is an alias to /src
import Slider from "@/components/Slider.vue";
import vSelect from 'vue-select'
import moment from "moment"
import 'vue-select/dist/vue-select.css';
import * as d3 from "d3"; // Do you really wanna import erything???
import app from '../../package.json'

vSelect.props.components.default = () => ({
  clearable: false,
  // Deselect: {
  //   render: createElement => createElement('span', '❌'),
  // },
  // OpenIndicator: {
  //   render: createElement => createElement('span', '√'),
  // },
});

export default {
  name: "home",
  data: () => {
    return {
        errors: [],
        dataset: [],
        filteredState: "All",
        filteredName: "All",
        filteredCostRange: "All",
        filteredDateMin: '1/1/2013',
        filteredDateMax: moment().format('M/1/YYYY'),
        costRange: [
          {
            text: '$0 - $999',
            range: [0, 999]
          },
          {
            text: '$1,000 - $9,999',
            range: [1000, 9999]
          },
          {
            text: '$10,000 - $99,999',
            range: [10000,99999]
          },
          {
            text: '$100,000 - $999,999',
            range: [100000,999999]
          },
          {
            text: '$1 million+',
            range: [1000000, -1]
          },
          {
            text: 'UNKOWN',
            range: -1
          },
        ],
        states: ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania", "Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"],
        ransomewareTypes: ["Bitpaymer", "Cerber", "CryptoLocker", "CryptoWall", "CrytoWall", "Dharma", "GandCrab", "Global 3", "HDDCryptor", "Hermes", "LeChiffre", "LockCrypt", "Megacode", "Nemesis", "OSIRIS", "PewCrypt", "RobbinHood", "Ryuk", "SamSam", "Scarab", "TeslaCrypt", "WannaCry", "UNKNOWN"],
      title: "Ransomware Attacks Map Version 0.1.5",
      googleSheetUrl:
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQyRkBqNzbPP_4lK_MDhLHTqKibzW1YvwHrw-IU4GSaXz4-wtictTXn1szSuJp84hi6JyjEnH3KdOR-/pub?gid=0&single=true&output=csv",
        RandsomwareAttacksDataset: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQyRkBqNzbPP_4lK_MDhLHTqKibzW1YvwHrw-IU4GSaXz4-wtictTXn1szSuJp84hi6JyjEnH3KdOR-/pub?gid=0&single=true&output=csv",
        // datasource: "https://docs.google.com/spreadsheets/d/e/2PACX-1vQyRkBqNzbPP_4lK_MDhLHTqKibzW1YvwHrw-IU4GSaXz4-wtictTXn1szSuJp84hi6JyjEnH3KdOR-/pub?gid=0&single=true&output=csv",
        datasource: 'https://s3.amazonaws.com/sng-global-web-assets/datasets/ransomware-map-dataset_update.csv',
        sponsor: 'https://s3.amazonaws.com/sng-global-web-assets/ransomware-map/sponsor.png'
    };
  },
  components: {
    Map,
    vSelect,
    Slider
  },
  computed: {
    enableSlider: function() {
      return this.$route.query.slider?this.$route.query.slider == 'true' : true
    },
    enableCounter: function(){
      return this.$route.query.counter?this.$route.query.counter == 'true' :true
    },
    hasErrors: function(){
      return this.errors.length > 0
    },
    datasetDates: function(){
      return this.dataset.map( data => data.Date )
    },
    filteredDataset: function(){
            
      let filteredState = this.filteredState
      let filteredCostRange = this.filteredCostRange.range
      let filteredDate  = [this.filteredDateMin, this.filteredDateMax]

      return this.dataset.filter( data => {
        let range = this.filteredCostRange.range
        let demand = this.parseCurrency(data.Demand)
        let dateObject = new Date(data.Date)
        
        let isDemandInRange = !range || this.isInRange(demand, range[0], range[1], 'UNKNOWN')
        let isOfType = (this.filteredName == 'All') || (data.Name == this.filteredName)
        let isInDateRange = dateObject >= new Date(this.filteredDateMin) && dateObject <= new Date(this.filteredDateMax)
        
        // (data.Name != 'CryptoLocker') &&
        return (this.filteredState == "All" || data.State == this.filteredState) &&
        (data.Demand == 'All' || isDemandInRange) &&
        (isInDateRange) &&
        (isOfType)
      })
    }
  },
  created() {
    window.RMap = {
      version: app.version || '0.1.9'
    }
    if (typeof fetch !== 'function') {
      console.warn('native fetch not available. Using polyfill')
      global.fetch = fetchPolyfill
    }
    this.loadDataset().then( dataset => {
      this.dataset = dataset

      let msg = "<Home> loadDataset(). see window.dataset"
      window.DD_LOGS && window.DD_LOGS.logger.info('Dataset loaded', { 
        datasetSize: this.dataset.length,
        lifecycle: 'created'
      })
    })
  },
  methods: {
    onSliderChange(dateRange){
      this.filteredDateMin=dateRange[0]
      this.filteredDateMax=dateRange[1]
    },
    onMapFailure(error){
      this.errors.push("Sorry, we're having issues fectching this map's topojson data.")
      console.error(`Failed to fetch map topojson.\n${error.message}.`)
    },
    isInRange(value, min, max, unknow='UNKNOWN'){
      let result  = false
      if( (value >= min) && (value <= max)){
        result    = true
      } else if( (max == null) && (min == null) ){
        result  = value == unknow
      } else if( (max == -1) && (value != unknow) ){
        result = value >= min
      }
      return result
    },
    filterByState(state) {
      console.log(`<Home> filtering dataset by ${state}!`)
    },
    async loadDataset() {
      return await d3.csv(this.datasource)
      .catch( error => {
        this.errors.push("Sorry, we're having issues loading dataset for this map.") 
        console.error(`Failed to fetch Google sheet dataset. Attempting S3 dataset.`)
      })
    },
    parseCurrency(currency=""){
      return currency.replace(/\$|,/gi,'')
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
// @import "vue-select/src/scss/vue-select.scss";

.grid--main {
  display: grid;
  grid-template-rows: repeat(10,1fr);
  grid-template-columns: repeat(10,1fr);
  width: 100vw;
  height: 100vh;
  margin-top: 10px;
}
.elevation-0 {
  position: relative;
  z-index: 0;
}
.elevation-1 {
  position: relative;
  z-index: 1;
}
section.top {
  display: grid;
  grid-template-columns: 390px auto;
  grid-column: 1/11;
  grid-row: 1/2;
  margin: 0 auto;
  max-width: 1080px;
  width: 100%;
}
section.map {
  overflow: hidden;
  grid-column: 1/11;
  grid-row: 2/11;
}
section.stats2 {
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  grid-row: 9/10;
  grid-column: 1/11;
  display: flex;
  justify-content: space-between;
}

div.sponsor {
  // width: 200px;
  // height: 100px;
  padding: 0px 10px;
  margin: 0px 0px 0px 30px;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  // justify-content: space-evenly;
  cursor: pointer;
}

div.sponsor img {
  max-width: 100px;
}

div.sponsor h4 {
  margin: 0px;
  padding: 0px 0px 11px 0px;
  color: #ffffff;
  font-size: 10px;
}
section.bottom {
  grid-row: 10/11;
  grid-column: 1/11;
  background-color: #000000;
}
div.active-events {
  background-color:#000000;
  color: #ffffff;
  width: 100px;
  font-size: 12px;
  padding-left: 10px;
  .num{
    font-family: 'Anton', sans-serif;
    font-size: 70px;
    font-weight: 400;
    font-size: 70px;
    margin-top: -10px;
  }
}
div.branding {
  display: flex;
  padding-left: 10px;
}
.filters {
  display: flex;
  justify-content: flex-end;
  color: #ffffff
}
.filters .tile {
  background-color: palevioletred;
}
.filters .title {
  font-family: Roboto Mono,sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #fff;
  text-align: left;
  padding-right: 20px;
  width: 120px;
}
.filters .filter {
  background-color: black !important;
  width: 200px;
  font-family: Roboto Mono,sans-serif !important;
  font-weight: 700;
  font-size: 12px;
  color: #fff;
  text-align: left;
  margin-right: 20px;
}

div.infographics {
  display: block;
  // max-width: 1000px;
  margin: 0 auto;
  // background-color: #318fe082;
}
div.infographics .filteredCount {
  background-color: rgb(124, 124, 124);
  height: 100px;
  width: 100px;
}
div#errors {
  display: flex;
  height: 100vh;
  justify-content: center;
  padding-top: 50vh;
  color: white;
  font-size: 20px;
}
@media screen and (max-width: 1040px){
  .filters .title {
    display: none;
  }
}
@media screen and (max-width: 900px){
  .filters .filter {
    width: 150px;
  }
}
@media screen and (max-width: 760px){
  section.top{
    grid-template-columns: 100%;
  }
  section.map{
    // display: flex;
    // align-items: center;
    padding-left: 10px;
  }
  .filters {
    flex-direction: column,
  }
  .filters .filter {
    width: 95%;
  }
}
</style>

<style lang="scss">
.v-select .vs__dropdown-toggle .vs__actions,
.v-select .vs__dropdown-toggle input.vs__search {
  cursor: pointer;
}
.v-select.filter-select .vs__dropdown-toggle {
  border: none;
  border-bottom: 1px solid white !important;
  border-radius: 0%;
}
.v-select.filter-select .vs__dropdown-toggle .vs__selected {
  color: #ffffff;
  font-size: 12px !important;
}
.v-select.filter-select .vs__dropdown-menu{
  background-color: black !important;
  margin-right: 20px;
  width: 200px;
  border: none;
  li{
    color: white;
    font-size: 12px !important;
    text-align: left !important;
    padding-left: .25em !important;
    margin-left: 4px !important;
  }
  li:hover,
  li:focus,
  li:highlighted {
    background-color: #2aff0f;
  }
}

.vs__dropdown-option--highlight{
    background-color: #2aff0f;
}
.v-select.filter-select .vs__clear,
.v-select.filter-select .vs__open-indicator {
  fill: #ffffff;
}
@media screen and (max-width: 900px){
  .v-select.filter-select .vs__dropdown-menu{
    width: 150px;
  }
}
@media screen and (max-width: 760px){
  .v-select.filter-select .vs__dropdown-menu{
    width: 100%;
  }
}
</style>